import CloseIcon from '@mui/icons-material/Close'
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material'

import { styles } from './TopicRefinementResponse.styles'

export const TEST_ID = 'TopicRefinementResponse'

export type Props = {
	backgroundColor?: string
	clearResponse?: VoidFunction
	contentText: string
	'data-testid'?: string
}

const TopicRefinementResponse = ({
	backgroundColor,
	contentText = '',
	clearResponse,
	'data-testid': dataTestId,
	...rest
}: Props) => {
	return (
		<Box
			data-testid={dataTestId ?? 'topic-refinement-response-container'}
			{...rest}
			sx={styles.container}
		>
			<Card sx={styles.card} variant="outlined">
				<CardContent sx={styles.cardContentReset}>
					<Box
						data-testid="topic-refinement-response-content-container"
						sx={[styles.contentBox, { backgroundColor }]}
					>
						<Typography sx={styles.contentText} variant="body1">
							{contentText}
						</Typography>
						{clearResponse && (
							<IconButton
								aria-label="clear topic refinement response"
								data-testid="topic-refinement-response-close-content-button"
								color="secondary"
								onClick={clearResponse}
							>
								<CloseIcon />
							</IconButton>
						)}
					</Box>
				</CardContent>
			</Card>
		</Box>
	)
}

export default TopicRefinementResponse
